import { AppBar, Avatar, Box, Button, Card, CardContent, Divider, Grid2, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Toolbar, Typography } from "@mui/material";
import axios from "axios";
import { useEffect, useRef, useState } from "react";
import { useLocation } from "react-router-dom";
import { useReactToPrint } from "react-to-print";
import Loader from "../util/Loader";
import LoadingAwal from "../util/LoadingAwal";
import { QRCodeSVG } from "qrcode.react";
import PrintIcon from '@mui/icons-material/Print';

const Row = ({row}) => {

    return <>
        <div key={row.uuid} className="page-break" sx={{Padding: 2}}/>
        <Card sx={{maxWidth: "md"}} className="BorderSolid">
            <CardContent>
                <Grid2 container spacing={2}>
                    <Grid2 size={6} justifyContent={"left"}>
                    <Typography
                        component="img"
                        src={`https://content.radboox.com/public/upload/img/${row.cp_logo}`}
                        alt="Company Profile"
                        style={{
                            align: "left",
                          objectFit: "contain",
                          backgroundColor: "#fff",
                        }}
                        sx={{ maxHeight: {xs: 50, sm: 75} }}
                      />
                    </Grid2>
                    <Grid2 size={6}>
                        <Typography align="right" sx={{fontWeight: {xs: 500, sm: 700}, fontSize: {xs: "20px", sm: "50px"}, lineHeight: 0.8}}>INVOICE</Typography>
                        <Typography align="right" variant="h5" sx={{fontWeight: 500}}>No: {row.noInvoice}</Typography>
                    </Grid2>
                    <Grid2 size={6}>
                        <Typography variant="h5" sx={{fontWeight: 700}}>{row.cp_name}</Typography>
                        <Typography variant="body1" sx={{fontWeight: 700, marginTop: 2}}>Address</Typography>
                        <Typography variant="body1" sx={{lineHeight: 1}}>{row.cp_address}</Typography>
                        <Typography variant="body1" sx={{lineHeight: 1}}>{row.cp_city} - {row.cp_country} {row.cp_code}</Typography>
                        <Grid2 container spacing={2}>
                            <Grid2 size={"auto"}>
                                <Typography variant="body1" sx={{fontWeight: 700, marginTop: 2}}>Phone</Typography>
                                <Typography variant="body1" sx={{lineHeight: 1}}>{row.cp_wa || "-"}</Typography>
                            </Grid2>
                            <Grid2 size={"auto"}>
                                <Typography variant="body1" sx={{fontWeight: 700, marginTop: 2}}>Email</Typography>
                                <Typography variant="body1" sx={{lineHeight: 1}}>{row.cp_email || "-"}</Typography>
                            </Grid2>
                        </Grid2>
                    </Grid2>
                    <Grid2 size={6}>
                        <Typography align="right" variant="body1" sx={{lineHeight: 1, marginTop: 2}}>Invoice Date</Typography>
                        <Typography align="right" variant="h6" sx={{lineHeight: 1}}>{row.invoiceDate}</Typography>
                        <Typography align="right" variant="body1" sx={{lineHeight: 1, marginTop: 2}}>Due Date</Typography>
                        <Typography align="right" variant="h6" sx={{lineHeight: 1}}>{row.dueDate}</Typography>
                    </Grid2>
                    <Grid2 size={12}>
                        <Divider />
                    </Grid2>
                    <Grid2 size={6}>
                        <Typography variant="body1" >Bill To :</Typography>
                        <Typography variant="h5" sx={{fontWeight: 700, marginTop: 1}}>{row.fullName}</Typography>
                        <Typography variant="body1" sx={{fontWeight: 700, marginTop: 0.2}}>Address</Typography>
                        <Typography variant="body1" sx={{lineHeight: 1}}>{row.address}</Typography>
                        <Grid2 container spacing={2}>
                            <Grid2  size={"auto"}>
                                <Typography variant="body1" sx={{fontWeight: 700, marginTop: 2}}>Phone</Typography>
                                <Typography variant="body1" sx={{lineHeight: 1}}>{row.wa || "-"}</Typography>
                            </Grid2>
                            <Grid2  size={"auto"}>
                                <Typography variant="body1" sx={{fontWeight: 700, marginTop: 2}}>Email</Typography>
                                <Typography variant="body1" sx={{lineHeight: 1}}>{row.email || "-"}</Typography>
                            </Grid2>
                        </Grid2>
                    </Grid2>
                    <Grid2 size={6}>
                        <Typography align="right" variant="h6" sx={{lineHeight: 1, marginTop: 2}}>Total (Rp)</Typography>
                        <Typography align="right" variant="h5" sx={{fontWeight: 700}}>{row.total}</Typography>
                        <Typography align="right" variant="h6" sx={{lineHeight: 1, marginTop: 2}}>Status</Typography>
                        <Typography align="right" variant="h5" sx={{fontWeight: 700, lineHeight: 1}}>{row.status === 1 ? "Unpaid" : "Paid"}</Typography>
                        {row.status === 2 && (
                            <>
                                <Typography align="right" variant="body1" sx={{marginTop: 1}}>Paid Date</Typography>
                                <Typography align="right" variant="h6" sx={{lineHeight: 1}}>{row.paidDate || "-"}</Typography>
                            </>
                        )}
                    </Grid2>
                    <Grid2 size={12} sx={{marginTop: 2}}>
                        <TableContainer>
                            <Table size="small">
                                <TableHead>
                                    <TableRow style={{backgroundColor: "#EAEAEB"}}>
                                        <TableCell>Description</TableCell>
                                        <TableCell align="right">Amount (Rp)</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    <TableRow>
                                        <TableCell>
                                            <Typography variant="body1" sx={{marginTop: 1}}>{row.item}</Typography>
                                            <Typography variant="body1" sx={{lineHeight: 1}}>Subscribe: {row.subscribe}</Typography>
                                        </TableCell>
                                        <TableCell align="right" sx={{fontWeight:500}}>{row.amount}</TableCell>
                                    </TableRow>
                                    <TableRow>
                                        <TableCell align="right">Sub Total</TableCell>
                                        <TableCell align="right" sx={{fontWeight:500}}>{row.amount}</TableCell>
                                    </TableRow>
                                    <TableRow>
                                        <TableCell align="right">PPN</TableCell>
                                        <TableCell align="right" sx={{fontWeight:500}}>{row.ppn}</TableCell>
                                    </TableRow>
                                    <TableRow>
                                        <TableCell align="right">Discount</TableCell>
                                        <TableCell align="right" sx={{fontWeight:500}}>{row.diskon}</TableCell>
                                    </TableRow>
                                    <TableRow>
                                        <TableCell align="right" sx={{fontWeight:700}}>Total</TableCell>
                                        <TableCell align="right" sx={{fontWeight:700}}>{row.total}</TableCell>
                                    </TableRow>
                                </TableBody>
                            </Table>
                        </TableContainer>
                    </Grid2>
                    <Grid2 size={6} sx={{marginTop: 2}}>
                        <Typography variant="body2" sx={{lineHeight: 1}}>ATTENTION</Typography>
                        <Typography variant="caption" sx={{lineHeight: 1}}>This invoice is issued every month, please pay on time</Typography>
                        <Box sx={{margin: 1}}><QRCodeSVG value={row.qr}/></Box>
                    </Grid2>
                    <Grid2 size={6} sx={{marginTop: 2}}>
                        <Typography variant="body1" sx={{ whiteSpace: "pre-wrap" }} align={'center'}>{row.signature}</Typography>
                    </Grid2>
                </Grid2>
            </CardContent>
        </Card>
    </>
}


const PrintInvoice = () => {

    const [rows, setRows] = useState([]);
    const [isLoad, setIsLoad] = useState(true);
    const contentRef = useRef(null);
    const location = useLocation();
    const idInvoice = new URLSearchParams(location.search).get('id_');
    const idUser = new URLSearchParams(location.search).get('u_');
    const [noInv, setNoInv] = useState([])
    useEffect(() => {
        const init = () => {
        axios.get(`https://ssr.radboox.com/data/invoice/client-print/${idUser}?id=${idInvoice}`)
        .then((res) => {
            const data = res.data.message;
            setRows(data)
            data.map((row) => (
                setNoInv(noInv => [...noInv, row.noInvoice])
            ))
            setIsLoad(false)
        }).catch((e) =>{
            setIsLoad(false)
        })
    }
        init();
    }, [idInvoice, idUser])

    const handlePrint = useReactToPrint({contentRef, documentTitle: `invoice-${noInv}`});

    return (
        <>
        {isLoad ? (
            <>
                <Loader />
                <LoadingAwal /> 
            </>) : (
            <>
                {rows.length > 0 ? (
                    <>
                    
                        <Box className="noPrint" sx={{marginBottom: 4}}>
                            <AppBar position="fixed" sx={{bgcolor: "#1f283e"}}>
                                <Toolbar>
                                    <Avatar alt="Remy Sharp" src={process.env.PUBLIC_URL + '/radboox-icon.png'} />
                                    <Typography
                                        variant="h6"
                                        noWrap
                                        component="a"
                                        href="https://www.radboox.com"
                                        sx={{
                                            mx: 2,
                                            fontSize: "26px",
                                            fontFamily: 'Roboto',
                                            fontWeight: 700,
                                            color: 'inherit',
                                            textDecoration: 'none',
                                        }}
                                    >
                                        RadbooX
                                    </Typography>
                                    <Box sx={{ flexGrow: 1 }} />
                                    <Button startIcon={<PrintIcon />} sx={{width: "128px", marginX: 1}} color="inherit" variant="outlined" onClick={() => handlePrint()} className="noPrint">Print</Button>
                                </Toolbar>
                            </AppBar>
                            <Toolbar />
                        </Box>
                        <Box display={"flex"} flexDirection={"column"} alignItems={"center"} ref={contentRef}>
                            {rows.map((row) => (
                                <Row key={row.uuid} row={row} />
                            ))}
                        </Box>
                    </>):(<>
                        <Box sx={{width: "100%", height: "70vh"}} display="flex" flexDirection="column" justifyContent='center' alignItems='center'>
                            <Typography variant="h2">404</Typography>
                            <Typography variant="h6">Invoice tidak dapat ditemukan</Typography>
                        </Box>
                    </>)
                }
            </>
        )}
        
        </>
    )
}

export default PrintInvoice;